<p>
  mat-snack-bar works!
</p>
